import { ValueType } from 'realgrid';

// 제조조성용 데이터 필드 정의
const fieldsManufacturing = [
  { fieldName: '구분', dataType: ValueType.TEXT },
  { fieldName: '고객사원료명칭', dataType: ValueType.TEXT },
  { fieldName: '사내통용명칭', dataType: ValueType.TEXT },
  { fieldName: '조성비', dataType: ValueType.TEXT },
  { fieldName: '실제조성', dataType: ValueType.TEXT },
  { fieldName: '희석용매', dataType: ValueType.TEXT },
  { fieldName: '희석비율', dataType: ValueType.TEXT },
  { fieldName: '반제품', dataType: ValueType.TEXT },
  { fieldName: '반제품함량', dataType: ValueType.TEXT },
  { fieldName: '희석용매함량', dataType: ValueType.TEXT },
  { fieldName: '제조조성', dataType: ValueType.TEXT },
  { fieldName: '제조조성비', dataType: ValueType.TEXT },
  { fieldName: 'changeYn', dataType: ValueType.TEXT },
  { fieldName: '_dilutionSolventOriginal', dataType: ValueType.TEXT },
  { fieldName: '_dilutionRatioValues', dataType: ValueType.TEXT },
  { fieldName: '_dilutionRatioLabels', dataType: ValueType.TEXT },
];

// 제조조성용 컬럼 정의 (1단 헤더)
const columnsManufacturing = [
  {
    name: '구분',
    fieldName: '구분',
    width: 80,
    editable: false,
    header: { text: '구분' },
    styles: { textAlignment: 'center' },
    mergeRule: { criteria: 'value' },
  },
  {
    name: '고객사원료명칭',
    fieldName: '고객사원료명칭',
    width: 140,
    editable: false,
    header: { text: '고객사원료명칭' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '사내통용명칭',
    fieldName: '사내통용명칭',
    width: 120,
    editable: false,
    header: { text: '사내통용명칭' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '조성비',
    fieldName: '조성비',
    width: 100,
    editable: false,
    header: { text: '조성비' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '실제조성',
    fieldName: '실제조성',
    width: 100,
    editable: false,
    header: { text: '실제조성' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '희석용매',
    fieldName: '희석용매',
    width: 100,
    editable: true,
    header: { text: '희석용매' },
    styles: { textAlignment: 'center' },
    editButtonVisibility: 'always',
    styleCallback: function (grid, dataCell) {
      var ret = {};
      var itemIndex = dataCell.index.itemIndex;
      var dataRow = grid.getDataRow ? grid.getDataRow(itemIndex) : dataCell.index.dataRow;

      if (dataRow == null || dataRow < 0) {
        ret.editor = { type: 'text', textReadOnly: true };
        ret.lookupDisplay = false;
        ret.editButtonVisibility = 'hidden';
        ret.editable = false;
        return ret;
      }
      var rowData = grid.getDataSource().getJsonRow(dataRow);
      var dilutionSolventStr = rowData ? rowData._dilutionSolventOriginal || '' : '';

      if (dilutionSolventStr && dilutionSolventStr !== '[]' && dilutionSolventStr.trim() !== '') {
        var values = [];
        var labels = [];
        try {
          var matches = dilutionSolventStr.match(/\{([^}]+)\}/g);
          if (matches && matches.length > 0) {
            matches.forEach(function (match) {
              var content = match.slice(1, -1);
              if (content.includes('=')) {
                var parts = content.split('=', 2);
                var value = (parts[0] || '').trim();
                var label = (parts[1] || '').trim();
                if (label !== '') {
                  values.push(value);
                  labels.push(label);
                }
              } else {
                var cleanContent = content.trim();
                if (cleanContent) {
                  values.push(cleanContent);
                  labels.push(cleanContent);
                }
              }
            });
          }
        } catch (e) {
          console.error('dilutionSolvent 파싱 오류:', e);
        }

        if (values.length > 0) {
          ret.editor = {
            type: 'dropdown',
            values: values,
            labels: labels,
            textReadOnly: true,
            domainOnly: true,
            dropDownWhenClick: true,
          };
          ret.lookupDisplay = true;
          ret.editButtonVisibility = 'always';
          ret.editable = true;
        } else {
          ret.editor = { type: 'text', textReadOnly: true };
          ret.lookupDisplay = false;
          ret.editButtonVisibility = 'hidden';
          ret.editable = false;
        }
      } else {
        ret.editor = { type: 'text', textReadOnly: true };
        ret.lookupDisplay = false;
        ret.editButtonVisibility = 'hidden';
        ret.editable = false;
      }
      return ret;
    },
    displayCallback: function (grid, index, value) {
      var itemIndex = index.itemIndex;
      var dataRow = grid.getDataRow ? grid.getDataRow(itemIndex) : index.dataRow;
      var retValue = value || '';
      if (dataRow == null || dataRow < 0) return retValue;
      var rowData = grid.getDataSource().getJsonRow(dataRow);
      var dilutionSolventStr = rowData ? rowData._dilutionSolventOriginal || '' : '';
      if (!dilutionSolventStr || dilutionSolventStr === '[]' || dilutionSolventStr.trim() === '') {
        retValue = '';
      }
      return retValue;
    },
  },
  {
    name: '희석비율',
    fieldName: '희석비율',
    width: 100,
    editable: true,
    header: { text: '희석비율' },
    styles: { textAlignment: 'center' },
    lookupDisplay: false,
    values: [],
    labels: [],
    editor: {
      type: 'text',
      textReadOnly: true,
    },
    editButtonVisibility: 'always',
    styleCallback: function (grid, dataCell) {
      var ret = {};
      var itemIndex = dataCell.index.itemIndex;
      var dataRow = grid.getDataRow ? grid.getDataRow(itemIndex) : dataCell.index.dataRow;

      if (dataRow == null || dataRow < 0) {
        ret.editor = { type: 'text', textReadOnly: true };
        ret.lookupDisplay = false;
        ret.editButtonVisibility = 'hidden';
        ret.editable = false;
        return ret;
      }

      // 해당 행의 희석용매 값 확인
      var dilutionSolventValue = grid.getValue(itemIndex, '희석용매');

      if (dilutionSolventValue && dilutionSolventValue.trim() !== '' && dilutionSolventValue !== '선택없음') {
        // 희석용매 값이 있는 경우 - 드롭다운으로 설정
        ret.editor = {
          type: 'dropdown',
          textReadOnly: true,
          domainOnly: true,
          dropDownWhenClick: true,
        };
        ret.lookupDisplay = true;
        ret.editButtonVisibility = 'always';
        ret.editable = true;

        // 해당 행의 데이터에서 동적으로 설정된 희석비율 옵션 가져오기
        var rowData = grid.getDataSource().getJsonRow(dataRow);
        if (rowData && rowData._dilutionRatioValues && rowData._dilutionRatioLabels) {
          try {
            var values = Array.isArray(rowData._dilutionRatioValues) ? rowData._dilutionRatioValues : JSON.parse(rowData._dilutionRatioValues);
            var labels = Array.isArray(rowData._dilutionRatioLabels) ? rowData._dilutionRatioLabels : JSON.parse(rowData._dilutionRatioLabels);
            ret.editor = {
              type: 'dropdown',
              textReadOnly: true,
              domainOnly: true,
              dropDownWhenClick: true,
              values: values,
              labels: labels,
            };
            ret.lookupDisplay = true;
            ret.editButtonVisibility = 'always';
            ret.editable = true;
          } catch (e) {
            ret.editor = {
              type: 'dropdown',
              textReadOnly: true,
              domainOnly: true,
              dropDownWhenClick: true,
              values: [''],
              labels: ['선택'],
            };
            ret.lookupDisplay = true;
            ret.editButtonVisibility = 'always';
            ret.editable = true;
          }
        } else {
          // 동적 옵션이 없는 경우 빈 드롭다운으로 시작
          ret.editor = {
            type: 'dropdown',
            textReadOnly: true,
            domainOnly: true,
            dropDownWhenClick: true,
            values: [''],
            labels: ['선택'],
          };
          ret.lookupDisplay = true;
          ret.editButtonVisibility = 'always';
          ret.editable = true;
        }
      } else {
        // 희석용매 값이 없는 경우 - 읽기 전용 텍스트로 설정
        ret.editor = { type: 'text', textReadOnly: true };
        ret.lookupDisplay = false;
        ret.editButtonVisibility = 'hidden';
        ret.editable = false;
      }

      return ret;
    },
  },
  {
    name: '반제품',
    fieldName: '반제품',
    width: 100,
    editable: false,
    header: { text: '반제품' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '반제품함량',
    fieldName: '반제품함량',
    width: 100,
    editable: false,
    header: { text: '반제품함량' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '희석용매함량',
    fieldName: '희석용매함량',
    width: 120,
    editable: false,
    header: { text: '희석용매함량' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '제조조성',
    fieldName: '제조조성',
    width: 100,
    editable: false,
    header: { text: '제조조성' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '제조조성비',
    fieldName: '제조조성비',
    width: 100,
    editable: false,
    header: { text: '제조조성비' },
    styles: { textAlignment: 'center' },
  },
];

// 제조조성용 컬럼 레이아웃 (1단 헤더이므로 단순한 배열)
const columnLayoutManufacturing = ['구분', '고객사원료명칭', '사내통용명칭', '조성비', '실제조성', '희석용매', '희석비율', '희석용매함량', '반제품', '반제품함량', '제조조성', '제조조성비'];

// 제조조성용 에러 메시지
const errorMessageManufacturing = '';

// 제조조성용 체크바 숨김 설정
const hideCheckBarManufacturing = true;

// 제조조성용 빈 그리드 설정
const blankGridManufacturing = true;

export { fieldsManufacturing, columnsManufacturing, columnLayoutManufacturing, errorMessageManufacturing, hideCheckBarManufacturing, blankGridManufacturing };
